import React from 'react';
import { WarningCircle, PaperPlaneTilt } from 'phosphor-react';
import { Button } from '@material-ui/core';

import EmailVerification from './EmailVerification';
import PhoneVerification from './PhoneVerification';
import { useSelector } from '../../../../lib/react-redux-hooks';
import {
  toggleEmailVerificationPrompt,
  togglePhoneVerificationPrompt,
} from '../../../../actions/dashboard';
import styles from '../../../../styles/sass/components/Dashboard.module.scss';

interface Props {
  dispatch: Function;
  user: any;
  token: string;
}

function VerificationComponent(props: Props) {
  const { emailVerified, phoneNumber, phoneNumberVerified } = props.user;
  const {
    emailVerificationSent,
    phoneVerificationSent,
    showEmailVerifyPrompt,
    showPhoneVerifyPrompt,
  } = useSelector((state: any) => {
    return {
      showEmailVerifyPrompt: state.dashboard.showEmailVerifyPrompt,
      showPhoneVerifyPrompt: state.dashboard.showPhoneVerifyPrompt,
      emailVerificationSent: state.dashboard.emailVerificationSent,
      phoneVerificationSent: state.dashboard.phoneVerificationSent,
    };
  });

  React.useEffect(() => {
    if (!emailVerified) {
      props.dispatch(toggleEmailVerificationPrompt(true));
    }
    if (!phoneNumberVerified) {
      props.dispatch(togglePhoneVerificationPrompt(true));
    }
  }, []);

  if (showEmailVerifyPrompt) {
    return (
      <EmailVerification
        dispatch={props.dispatch}
        emailVerified={emailVerified}
        emailVerificationSent={emailVerificationSent}
        token={props.token}
      />
    );
  }
  if (showPhoneVerifyPrompt) {
    return (
      <PhoneVerification
        dispatch={props.dispatch}
        phoneNumber={phoneNumber}
        phoneNumberVerified={phoneNumberVerified}
        phoneVerificationSent={phoneVerificationSent}
        token={props.token}
      />
    );
  }
  if (emailVerified && phoneNumberVerified) {
    return null;
  }
  return null;
}

export default VerificationComponent;
